awardData.classy.controller({
    name: 'AwardDataDepChildsController',
    inject: ['$scope', '$modal', '$timeout', 
        'ApplicationService', 'authServiceFactory', 'SchoolModelService', 'EditApplicantsModalService', 
        'ModelService', 'CalculationService', 'ChildrenModelFactory', 
        'DependantModelFactory', 'SliderService'],
    init: function()
    {
        this.$.$modalInstance = this.$modalInstance;
        this.$.authServiceFactory = this.authServiceFactory
        this.$.SliderService = this.SliderService;
        this.$.ApplicationService = this.ApplicationService;

        var parent = this;
        this.$.familyIndex = this.familyIndex;
        this.familyID = this.ApplicationService.getFamilyData().data[0].familyID;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.anonymous = this.$.schoolinfo.Anonymous;
        this.$.models = [];
        this.$.models[0] = new this.DependantModelFactory(this.familyID); //deps
        this.$.models[1] = new this.ChildrenModelFactory(this.familyID); //childs
        this.$.dependents = this.ApplicationService.getFamilyData().dependant;
        this.$.children = this.ApplicationService.getFamilyData().children;
        this.initOpened();
        this.$.versionNo = versionNo;
        this.$.showEdit = false;
        this.$.depEdit = false;
        this.$.childEdit = false;
        //Make a service when needed
        this.$.gradeLabel = {P: 'Pre-K', K: 'Kindergarten', 1:'1st Grade', 2:' 2nd Grade', 3:'3rd Grade', 4:'4th Grade',
            5:'5th Grade', 6:'6th Grade', 7:'7th Grade', 8:'8th Grade', 9:'9th Grade', 10:'10th Grade', 11:'11th Grade',
            12: '12th Grade', 13: 'Post-Grad'};
        //Date Picker Stuff
        this.$.dateOptions = { formatYear: 'yy', startingDay: 1 };
        this.$.minDate = new Date('1900-01-01');
        this.$.maxDate = new Date();
        this.$.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate', 'yyyymmdd'];
        this.$.format = this.$.formats[0];
        this.$.confidential = this.authServiceFactory.getAuth().permissions.confidential;

        this.$timeout(function() {
            $(window).on('resize', function() {
                var slideoutTabHeight = $(".slideout-tabs .nav-tabs").height();
                $(".data-start").css("margin-top", slideoutTabHeight + 'px');
            }).trigger('resize');
            $( ".depFirstName, .depLastName, .chiFirstName, .chiLastName" ).keypress(function() {
                var slideoutTabHeight = $(".slideout-tabs .nav-tabs").height();
                $(".data-start").css("margin-top", slideoutTabHeight + 'px');
            }).trigger('resize');
        }, 100);

        /*this.$.$watch(function() {return parent.$.SliderService.getParams();}, function() {
            //set active tab
            for (var i = 0; i < parent.$.dependents.length; i++) {
                parent.$.dependents[i].active = false;
            }
            for (var i = 0; i < parent.$.children.length; i++) {
                parent.$.children[i].active = false;
            }
            if (parent.SliderService.getParams()!==undefined) {
                if (parent.SliderService.getParams().tab!=undefined) {
                    if (parent.SliderService.getParams().type=='d')
                        parent.$.dependents[parent.SliderService.getParams().tab].active = true;
                    else if (parent.SliderService.getParams().type=='c') {
                        parent.$.children[parent.SliderService.getParams().tab].active = true;
                    }
                }
            }
            else if (parent.$.children.length>0) parent.$.children[0].active = true;
        });*/
        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;
    },
    watch: {
        'this.SliderService.returnSliders()': function(oldValue, newValue) {
            if (this.$.SliderService.returnSliders().length>0) {
                for (var j = 0; j < this.$.SliderService.returnSliders().length; j++) {
                    if (this.$.SliderService.returnSliders()[j].partial.indexOf("DepChilds") >= 0) {
                        var ind = this.$.SliderService.returnSliders()[j].paramObj.tab
                        var type = this.$.SliderService.returnSliders()[j].paramObj.type
                    }
                }
                for (var i = 0; i < this.$.children.length; i++) {
                    this.$.children[i].active = false;
                }
                for (var i = 0; i < this.$.dependents.length; i++) {
                    this.$.dependents[i].active = false;
                }
                if (ind!==undefined) {
                    if (type=='c')
                        this.$.children[ind].active = true;
                    else if (type=='d')
                        this.$.dependents[ind].active = true;
                }
            }
        }
    },
    initOpened: function()
    {
        this.edited = Array();
        this.opened = Array();
        this.$.xChi_DOB = Array();
        for (var j = 0; j < 2; j++) {
            this.edited[j] = Array();
            this.opened[j] = Array();
            for (var i = 0; i < this.$.models[j].get().length; i++) {
                this.edited[j][i] = false;
                this.opened[j][i] = false;
                if (j==1)
                    this.$.xChi_DOB[i] = this.$.children[i].xChi_DOB.toString().getDateMysqlReversed();
            }
        } 
    },
    getField: function(item, field)
    {
        if (item['x' + field] === null || item[field] == item['x' + field])
            return item[field]
        else
            return item['x' + field];
    },
    newDep: function(type, $event)
    {
        $event.preventDefault();
        $event.stopPropagation();
        var ind = this.$.models[type].new(this.$.familyIndex);
        if (type==0) {
            this.$.dependents = this.$.models[type].get();
            this.$.dependents[ind].active = true;
        }
        else {
            this.$.children = this.$.models[type].get();
            this.$.children[ind].active = true;
        }
        this.initOpened();
        this.toggleEdit(type, ind);
        this.$timeout(function() {
            $(".slideout-tabs").click();
            function navTabResize () {
                var slideoutTabHeight = $(".slideout-tabs .nav-tabs").height();
                $(".data-start").css("margin-top", slideoutTabHeight + 'px');
            };

            $(window).on("resize", function() {
                navTabResize();
            }).trigger("resize");

            $(window).on("onload", function() {
                navTabResize();
            }).trigger("onload");
            $( ".depFirstName, .depLastName, .chiFirstName, .chiLastName" ).keypress(function() {
                var slideoutTabHeight = $(".slideout-tabs .nav-tabs").height();
                $(".data-start").css("margin-top", slideoutTabHeight + 'px');
            }).trigger('resize');
        }, 300);
    },
    childChange: function(item, date)
    {
        item.Chi_DOB = date.getDateMySqlFormatted().replaceAll("-", "")
    },
    depChange: function(item, date)
    {
        item.Dep_DOB = date.getDateMySqlFormatted().replaceAll("-", "")
    },
    getOpened: function(type, index)
    {
        return this.opened[type][index];
    },
    getEdited: function(type, index)
    {
        return this.edited[type][index];
    },
    toggleOpen: function(type, index)
    {
        if (this.opened[type][index] == false)
            this.initOpened();
        this.opened[type][index] = !this.opened[type][index];

    },
    toggleEdit: function(type, index)
    {
        var parent = this;
        if (type==0) {
            this.$.dependents[index].active = true;
            angular.forEach(this.$.dependents[index], function(value, key) {
                if ((parent.$.dependents[index]['x'+key]!==undefined) && (parent.$.dependents[index]['x'+key]==null)) {
                    parent.$.dependents[index]['x'+key] = parent.$.dependents[index][key];
                }
            });    
        }
        else if (type==1) {
            this.$.children[index].active = true;
            angular.forEach(this.$.children[index], function(value, key) {
                if ((parent.$.children[index]['x'+key]!==undefined) && (parent.$.children[index]['x'+key]==null)) {
                    parent.$.children[index]['x'+key] = parent.$.children[index][key];
                }
            });
        }
        if (this.edited[type][index] == false)
            this.initOpened();
        this.edited[type][index] = !this.edited[type][index];
    },
    dismiss: function(type)
    {
        if (type==0) {
            this.ApplicationService.getFamilyData().dependant.pop();
        }
        else {
            this.ApplicationService.getFamilyData().children.pop();
        }
    },
    startSaveProcess: function(scope, instance, form, type, index)
    {
        if (form.$valid)
        {
            this.edited[type][index] = !this.edited[type][index];
            instance.options.factor = .5;

            if (type==0) {
                if ((typeof this.$.dependents[index].recordID !== 'undefined'))
                    return this.$.models[type].put(this.$.dependents[index].recordID, this.$.dependents[index], instance)
                else {
                    this.savePut(type, index);
                    return this.$.models[type].post(this.familyID, this.$.dependents[index], instance)
                }
            }
            else if (type==1) {          
                this.$.children[index].xChi_DOB = this.$.xChi_DOB[index]
                this.$.children[index].xChi_DOB = this.$.children[index].xChi_DOB.toString().getDateMysqlRegular()
                if ((typeof this.$.children[index].recordID !== 'undefined'))
                    return this.$.models[type].put(this.$.children[index].recordID, this.$.children[index], instance)
                else {
                    this.savePut(type, index);
                    this.$.models[type].post(this.familyID, this.$.children[index], instance)
                    this.livingAllowancePut(1);
                }
            }
        }
        else
            instance.stop(-1);
    },
    startDeleteProcess: function(scope, instance, form, type, index)
    {
        instance.options.factor = .5;
        var parent = this;
        if (type === 0) {
            this.$.models[type].purge(this.familyID, this.$.dependents[index], instance).then(function(results) {
                parent.$.dependents[index].deleted = 1;
            });
        }
        else if (type === 1) {
            this.$.models[type].purge(this.familyID, this.$.children[index], instance).then(function(results) {
                parent.$.children[index].deleted = 1;
            });
            this.livingAllowancePut(-1);
        }
    },
    successSave: function (scope, instance, type, index, callback)
    {
        this.edited = [];
        if (instance.options.config.method === "POST")
        {
            if (type === 0) {
                this.$.dependents[index].recordID = instance.options.data.id;
                this.$scope.$apply();
            }
            else {
                this.$.children[index].recordID = instance.options.data.id;
                this.$scope.$apply();
            }
        }
        this.initOpened();
        if (typeof callback !== "undefined")
            callback();
    },
    successDelete: function (scope, instance, type, index)
    {
        this.edited[type][index] = !this.edited[type][index];
        this.edited = [];
        if (type === 0) {
            this.ApplicationService.getFamilyData().dependant.splice(index, 1);
            this.$.dependents.splice(index, 1);
        }
        else if (type === 1) {
            this.ApplicationService.getFamilyData().children.splice(index, 1);
            this.$.children.splice(index, 1);
        }
        this.initOpened();
    },
    livingAllowancePut: function(number)
    {
        var dataThresh = this.ApplicationService.getFamilyData().thresholds;
        var dataEditSums = this.ApplicationService.getFamilyData().edit_sums;

        var putDataThresh = {};
        var putDataEditSums = {};

        putDataThresh.Thresh_Living_Allowance = dataThresh.Thresh_Living_Allowance;
        putDataThresh.Thresh_Allow_Per_Child = dataThresh.Thresh_Allow_Per_Child;

        putDataEditSums.Child_Count = parseInt(dataEditSums.Child_Count)+number;

        this.ModelService.FamilyThreshEditSumsService
            .putHelper(dataThresh, dataEditSums, putDataThresh, putDataEditSums)
            .then(() => {
                this.CalculationService.reCalc();
            });
    },
    savePut: function(type, index) {
        var parent = this; 
        if (type==0) {
            angular.forEach(this.$.dependents[index], function(value, key) {
                    if ((parent.$.dependents[index][key]!==undefined) && (parent.$.dependents[index][key]=='')) {
                        parent.$.dependents[index][key] = parent.$.dependents[index]['x'+key];
                    }
                }); 
        }
        else if (type==1) {
            angular.forEach(this.$.children[index], function(value, key) {
                    if ((parent.$.children[index][key]!==undefined) && (parent.$.children[index][key]==='')) {
                        parent.$.children[index][key] = parent.$.children[index]['x'+key];
                    }
                }); 
        }
    },
    convert: function(item, index)
    {
        this.EditApplicantsModalService.setItem(item);
        this.EditApplicantsModalService.setIndex(index);
        return this.$modal.open({
            templateUrl: 'fast/submodules/schoolside/applications/submodules/tabs/submodules/edit/partials/convertModal.html?v='+versionNo,
            controller: 'ConvertModalController',
            backdrop: 'static',
            keyboard: false
        });
    }
});
